import { render, staticRenderFns } from "./AddCategoryPage.vue?vue&type=template&id=e0d34180"
import script from "./AddCategoryPage.vue?vue&type=script&lang=js"
export * from "./AddCategoryPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports